import { createBaseAction } from '@essent/common';

import type { ConsentContainerRendering } from '../../models';

export const setConsentRendering = createBaseAction<ConsentContainerRendering>(
  '[Consent Rendering] Set consent rendering'
);
